import {gsap, Power4} from 'gsap'
import IntersectionObserver from 'intersection-observer-polyfill'

export default function()  {
    let elements = document.querySelectorAll('[data-fade]')
    
    let Observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) =>{
            if (entry.intersectionRatio > 0) {
                gsap.to(entry.target, .8, {
                    y: 0,
                    opacity: 1,
                    delay: 0.3,
                    ease: Power4.easeOut,
                    onComplete: () => {
                        gsap.set(entry.target, {clearProps: 'all'})
                    }
                })
                let text = entry.target
                Observer.unobserve(text)
            }
        })
    })
    elements.forEach((text) => {
        Observer.observe(text)
    })
}